export default {
  RESPONSE_CODES: {
    serverError: 500,
    success:200,
    forbidden:403,
    notFound:404
  },
  IDENTITY_ERROR_MESSAGE:"User requires 2FA",
  STATUS: {
    draft: {
      name: 'Draft',
      color: '#505050',
      value: 'draft',
    },
    schedule: {
      name: 'Scheduled',
      color: '#FFB933',
      value: 'schedule',
    },
    scheduled: {
      name: 'Scheduled',
      color: '#FFB933',
      value: 'scheduled',
    },
    active: {
      name: 'Active',
      color: '#41CE65',
      value: 'active',
    },
    sent: {
      name: 'Sent',
      color: '#41CE65',
      value: 'sent',
    },
    failed:{
      name: 'Failed',
      color: 'red',
      value: "failed"
    },
    workflow: {
      name: 'Journeys',
      color: '#03B6FC',
      value: 'workflow',
    },
    recurring: {
      name: 'Recurring',
      color: '#03B6FC',
      value: 'recurring',
    },
    test: {
      name: 'A/B Campaigns',
      color: 'pink',
      value: 'test',
    },
    locked: {
      name: 'Locked',
      color: 'red',
      value: 'locked',
    },
    stopped: {
      name: 'Stopped',
      color: 'red',
      value: 'stopped',
    },
    wi: {
      name: 'jrny',
      color: 'grey',
      value: 'jnry',
    },
    trans: {
      name: 'Trans',
      color: 'grey',
      value: 'trans',
    },
    Sent: {
      name: 'Sent',
      color: '#03B6FC',
      value: 'Sent',
    },
    delivered: {
      name: 'Delivered',
      color: '#4C5463',
      value: 'Delivered',
    },
    received: {
      name: 'Received',
      color: '#4C5463',
      value: 'received',
    },
    opened: {
      name: 'Opened',
      color: '#67D884',
      value: 'Opened',
    },
    clicked: {
      name: 'Clicked',
      color: '#826AF9',
      value: 'Clicked',
    },
    bounced: {
      name: 'Bounced',
      color: '#F53BAD',
      value: 'Bounced',
    },
    complaints: {
      name: 'Complaints',
      color: '#FFBF4A',
      value: 'Complaints',
    },
    Unsubscribed: {
      name: 'Unsubscribed',
      color: 'grey',
      value: 'Unsubscribed',
    },
    unsubscribed: {
      name: 'Unsubscribed',
      color: 'grey',
      value: 'Unsubscribed',
    },
    Cleansed: {
      name: 'Cleansed',
      color: 'grey',
      value: 'Cleansed',
    },
    Active: {
      name: 'Active',
      color: '#41CE65',
      value: 'Active',
    },
    Paused: {
      name: 'Paused',
      color: 'grey',
      value: 'Paused',
    },
    Finished: {
      name: 'Finished',
      color: 'grey',
      value: 'Finished',
    },
    paid: {
      name: 'Paid',
      color: '#67D884',
      value: 'Paid',
    },
    new: {
      name: 'New',
      color: 'grey',
      value: 'New',
    },
    onhold: {
      name: 'On Hold',
      color: 'red',
      value: 'On Hold',
    }
  },
  TICKET_STATUS: {
    new: {
      name: 'New',
      color: '#03B6FC',
      value: 'new',
    },
    closed: {
      name: 'Closed',
      color: '#41CE65',
      value: 'closed',
    },
    open: {
      name: 'Open',
      color: '#F53B57',
      value: 'open',
    },
    pending: {
      name: 'Pending',
      color: '#ffbf4a',
      value: 'pending',
    },
    on_hold: {
      name: 'On Hold',
      color: '#F53BAD',
      value: 'on_hold',
    },
  },
  PRIORITY: {
    low: {
      name: 'Low',
      color: '#727272',
      value: 'low',
    },
    medium: {
      name: 'Medium',
      color: '#06b6fc',
      value: 'medium',
    },
    high: {
      name: 'High',
      color: '#f3425c',
      value: 'high',
    }
  },

  PRIORITY_COLORS:{
    low:"#03B6FC",
    medium:"#E88900",
    high:"#F53B57"
  },

  MAROPOST_PRODUCTS:{
    marketingCloud:"marketing_cloud",
    serviceCloud:"service_cloud"
  },
  PRODUCT_IDENTFIERS: {
    mmc: { id: "mmc", type: "emails" },
    msc: { id: "msc", type: "ticket" }
  },
  USAGE_CHART_COLORS:{
    usage:"#03B6FC",
    pending:"#CDF0FE",
    overage:"#F3425C"
  },
  /**
     * Emails
     */
   OFFICIAL_EMAILS:{
    SUPPORT_EMAIL: 'support@maropost.com',
    ACCOUNT_CHANGES_EMAIL: 'subscriptions@maropost.com',
    BILLING_EMAIL: 'billing@maropost.com'
  },
  /**
   * Language list 
   */
  LANGAUGE_LIST: [
    { name: 'English', value: 'en' },
    { name: 'Spanish', value: 'es' },
    { name: 'German', value: 'de' },
    { name: 'Italian', value: 'it' },
    { name: 'French', value: 'fr' },
    { name: 'Portuguese', value: 'pt' },
    { name: 'Polish', value: 'pl' },
    { name: 'Danish', value: 'da' },
    { value: 'zh', name: 'Chinese'},
    { name: 'Dutch', value: 'nl' },
    { name: 'Swedish', value: 'sv' },
    { name: 'Norwegian', value: 'no' }
  ],
  ORDER_STATUS: {
    new: {
      name: 'New',
      color: '#03b6fc',
    },
    dispatched: {
      name: 'Dispatched',
      color: '#41CE65',
    },
    paid: {
      name: 'Paid',
      color: '#41CE65',
    },
    pending: {
      name: 'Pending',
      color: '#E88900',
    },
    processed: {
      name: 'Processed',
      color: '#5bc0de',
    },
    cancelled: {
      name: 'Cancelled',
      color: '#F53B57',
    },
    'on hold': {
      name: 'On Hold',
      color: '#E88900',
    },
    'invalid card': {
      name: 'Invalid Card',
      color: '#B00020',
    },
    'in transit': {
      name: 'In Transit',
      color: '#826af9',
    },
    complete: {
      name: 'Complete',
      color: '#67D884',
    },
    Completed: {
      name: 'Completed',
      color: '#67D884',
    },
    pick: {
      name: 'Pick',
      color: '#E88900',
    },
    pack: {
      name: 'Pack',
      color: '#E88900',
    },
    'backorder approved': {
      name: 'Backorder Approved',
      color: '#41CE65',
    },
    'new backorder': {
      name: 'New Backorder',
      color: '#03b6fc',
    },
    'fulfilled': {
      name: 'Fulfilled',
      color: '#41CE65',
    },
    'unfulfilled': {
      name: 'Unfulfilled',
      color: '#E88900',
    },
    default: {
      name: 'Default',
      color: '#818181',
    },
  },
}

/**
* Compute Route Prefix on basis Product Type Environment Variable.
*/
export const ROUTE_PREFIX = process.env.VUE_APP_PRODUCT == 'Marketing' ? "/accounts" : ""
